export default __webpack_public_path__ + "static/media/flag_eu.661ad874.png";